const formater = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
  currencyDisplay: 'code',
});

/**
 * Convierte un valor numérico a formato moneda.
 * @param {*} val Valor numérico a convertir
 * @returns {String}
 */
module.exports = (val = 0) => {
  let value = parseFloat(val);
  if (typeof value !== 'number' || Number.isNaN(value)) {
    value = 0;
  }

  const formated = formater.format(value);
  const idx = [...formated].findIndex((d) => /[0-9]/.test(d));
  const output = formated.substr(idx);

  return `$${output}`;
};
